'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$0024 from "./presto.-Login-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002445 from "./presto.-Presto-Router$$anon$45.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$44() {
  this.bjz = null;
  this.bjr = null;
  this.bjs = false;
  this.bjA = null;
  this.bjB = false;
  this.bjE = null;
  this.bjx = null;
  this.bjy = false;
  this.bjt = null;
  this.bju = false;
  this.bjv = null;
  this.bjw = false;
  this.bjC = false;
  this.bjD = false;
  this.bjz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bjE = "LoginPage";
}
export { $c_Lpresto_PrestoRouter$$anon$44 as $c_Lpresto_PrestoRouter$$anon$44 };
$p = $c_Lpresto_PrestoRouter$$anon$44.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$44;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$44() {
}
export { $h_Lpresto_PrestoRouter$$anon$44 as $h_Lpresto_PrestoRouter$$anon$44 };
$h_Lpresto_PrestoRouter$$anon$44.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bjz;
});
$p.M = (function() {
  if ((!this.bjs)) {
    this.bjr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bjs = true;
  }
  return this.bjr;
});
$p.O = (function() {
  if ((!this.bjB)) {
    this.bjA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bjB = true;
  }
  return this.bjA;
});
$p.D = (function() {
  return this.bjE;
});
$p.t = (function() {
  if ((!this.bjy)) {
    this.bjx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bjy = true;
  }
  return this.bjx;
});
$p.N = (function() {
  if ((!this.bju)) {
    this.bjt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bju = true;
  }
  return this.bjt;
});
$p.Q = (function() {
  if ((!this.bjw)) {
    this.bjv = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002445.$c_Lpresto_PrestoRouter$$anon$45();
    this.bjw = true;
  }
  return this.bjv;
});
$p.v = (function() {
  if ((!this.bjD)) {
    this.bjC = false;
    this.bjD = true;
  }
  return this.bjC;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee370) => ((p) => \u03b4scrutinee370))($j_presto$002e$002dLogin$002dPage$0024.$m_Lpresto_LoginPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$44 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$44, "presto.PrestoRouter$$anon$44", ({
  Oj: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$44 as $d_Lpresto_PrestoRouter$$anon$44 };
//# sourceMappingURL=presto.-Presto-Router$$anon$44.js.map
